import React from 'react';
import { Box, CardContent, Grid, Tooltip, Typography } from '@mui/material';
import { Help as HelpIcon } from '@mui/icons-material';
import { BaseCard } from './Dashboard/DashboardTableCard';
import OverlayLoader from './OverlayLoader';
import { Colors } from '../assets/theme/Colors';

const EnviroImpactCard = ({
  title,
  subTitle = '',
  value,
  isLoading,
  cardStyle,
  children,
  iconSize = 72,
  valueFontVariant = 'h5',
  textStyle = {},
  textVariant = 'body2',
  noShadow = false,
  showTooltip = false,
  tooltipText = '',
}) => (
  <OverlayLoader wrapperStyles={{ height: '100%' }} isLoading={isLoading}>
    <BaseCard sx={cardStyle} noShadow={noShadow}>
      <CardContent>
        <Grid container spacing={1}>
          <Grid item xs={4}>
            <Box display="flex" justifyContent="center" alignItems="center" fontSize={iconSize}>
              {children}
            </Box>
          </Grid>
          <Grid item xs={8}>
            <Box display="flex" flexDirection="column" justifyContent="center" height="100%">
              <Typography align="center" variant={textVariant} color="textSecondary" style={textStyle}>
                {title}
              </Typography>
              <Typography
                style={{ overflowWrap: 'anywhere', fontWeight: 700 }}
                align="center"
                variant={valueFontVariant}
              >
                {value}
              </Typography>
              <Typography align="center" variant={textVariant} color="textSecondary" style={textStyle}>
                {subTitle}
              </Typography>
            </Box>
          </Grid>
        </Grid>
        {showTooltip && (
          <Box style={{ position: 'absolute', top: 5, right: 5 }}>
            <Tooltip arrow placement="top" title={tooltipText} leaveTouchDelay={5000}>
              <HelpIcon htmlColor={Colors.blue.main} />
            </Tooltip>
          </Box>
        )}
      </CardContent>
    </BaseCard>
  </OverlayLoader>
);

export default EnviroImpactCard;
